<template>
  <div v-if="hasVisibleFields"
       class="registration-form__practice-type-container">
    <fieldset v-show="formFields.practiceSetting 
                && !formFields.practiceSetting.isHidden"
              id="practiceSettingField"
              class="wk-js2 registration-form-field">
      <UtdSelect id="practiceSettingSelect"
                 :selected="form.practiceSetting"
                 :options="practiceSettingOptions"
                 label="Practice Setting"
                 required
                 placeholder="Select your practice setting"
                 :use-index="false"
                 @input="emit('selectChange', { value: $event, name: REG_FIELD.PRACTICE_SETTING })"
      />
    </fieldset>
    
    <fieldset v-show="formFields.practiceType && !formFields.practiceType.isHidden"
              id="practiceTypeField" 
              class="wk-js2 registration-form-field">
      <UtdSelect id="roleSelect"
                 :selected="form.practiceType"
                 :options="roleOptions"
                 label="Role"
                 required
                 placeholder="Select your role"
                 :use-index="false"
                 @input="emit('selectChange', { value: $event, name: REG_FIELD.PRACTICE_TYPE })"
      />
    </fieldset>
    
    <fieldset v-show="formFields.specialty && !formFields.specialty.isHidden" 
              id="specialtyField"
              class="wk-js2 registration-form-field">
      <UtdSelect id="specialtySelect"
                 :selected="form.specialty"
                 :options="specialtyOptions"
                 label="Specialty"
                 required
                 placeholder="Select your specialty"
                 :use-index="false"
                 @input="emit('selectChange', { value: $event, name: REG_FIELD.SPECIALTY })"
      />
    </fieldset>
  </div>
</template>

<script setup>
import UtdSelect from '_acaSrc/components/shared/input/UtdSelect.vue';
import useRegistrationForm from '_acaSrc/composables/registrationForm.composable';
import { useStore } from 'vuex';
import { computed } from 'vue';
import { REG_FIELD } from '_acaSrc/utility/constants';

const store = useStore();

const practiceSettingOptions = computed(() => 
    store.getters['account/myAccountPracticeSettingOptions']
);
const roleOptions = computed(() => store.getters['account/myAccountpracticeTypeOptions']);
const specialtyOptions = computed(() => store.getters['account/myAccountSpecialtyOptions']);

const registrationForm = computed(() => store.getters['login/registrationForm']);
const formFields = computed(() => registrationForm.value.formFields);

const hasVisibleFields = computed(() => {
    return (formFields.value.practiceSetting && !formFields.value.practiceSetting.isHidden) ||
           (formFields.value.practiceType && !formFields.value.practiceType.isHidden) ||
           (formFields.value.specialty && !formFields.value.specialty.isHidden);
});

const emit = defineEmits([
    'selectChange'
]);

const {
    form
} = useRegistrationForm();
</script>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';

.registration-form__practice-type-container {
  .ds1-pa-2();
  .ds1-mb-3();
  background-color: @DS2-UTD-SELECT-CONTAINER-BG-COLOR;
  border: @DS2-UTD-FOOTER-DIVIDER-BORDER-COLOR;
}
</style>